module.exports = [{
      plugin: require('/home/domo/Documents/Workspace/projekt-mama/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Roboto:400,500,700","EB Garamond:400,700"]}},
    }]
